import React from 'react';
import { Link, NavLink } from 'react-router';

import './PublicShell.css';

export default function PublicShell({
    children,
    compact = false,
    document = false,
    authenticated = false,
}) {
    const shellClassName = [
        'public-shell',
        compact ? 'public-shell--compact' : '',
        document ? 'public-shell--document' : '',
    ].filter(Boolean).join(' ');

    return (
        <div className={shellClassName}>
            <a className="public-shell__skip-link" href="#public-main">Skip to content</a>

            <header className="public-shell__header">
                <Link className="public-shell__brand" to="/" aria-label="Progress Lands home">
                    <span className="public-shell__logo-frame" aria-hidden="true">
                        <img
                            className="public-shell__logo"
                            src="/logo192.png"
                            alt=""
                            width="52"
                            height="52"
                        />
                    </span>
                    <span className="public-shell__brand-copy">
                        <span className="public-shell__brand-name">Progress Lands</span>
                        <span className="public-shell__brand-tag">Closed alpha</span>
                    </span>
                </Link>

                <nav className="public-shell__nav" aria-label="Public navigation">
                    {!authenticated && (
                        <>
                            <NavLink to="/login">Log in</NavLink>
                            <NavLink className="public-shell__nav-cta" to="/register">Pre-register</NavLink>
                        </>
                    )}
                    <NavLink to="/wiki">Wiki</NavLink>
                    <NavLink to="/changelog">Release notes</NavLink>
                </nav>
            </header>

            <main id="public-main" className="public-shell__main">
                {children}
            </main>
        </div>
    );
}
